import { effect, Injectable, signal, inject } from '@angular/core';
import { BrowserStorageService } from './browser-storage-service';

export type SidebarType = 'main' | 'reg' | 'paper' | 'badge' | 'tenant' | 'campaign' | 'website' | 'program' | 'chatbot';
const SIDEBAR_KEY = 'app-sidebar-type';
@Injectable({
  providedIn: 'root'
})

export class SidebarService {
  private browserStorage = inject(BrowserStorageService);

  sidebarType = signal<SidebarType>(
    (this.browserStorage.getSessionItem(SIDEBAR_KEY) as SidebarType) || 'main'
  );

  isSidenavOpen = signal<boolean>(true);

  constructor() {
    // Effect: sync to sessionStorage whenever sidebarType changes
    effect(() => {
      const value = this.sidebarType();
      this.browserStorage.setSessionItem(SIDEBAR_KEY, value);
    });
  }

  setSidebar(type: SidebarType) {
    this.sidebarType.set(type);
  }

  cycleSidebar() {
    const order: SidebarType[] = ['main', 'reg', 'paper', 'website', 'program', 'chatbot'];
    const currentIndex = order.indexOf(this.sidebarType());
    const nextIndex = (currentIndex + 1) % order.length;
    this.sidebarType.set(order[nextIndex]);
  }

  toggleSidenav() {
    this.isSidenavOpen.update((val) => !val);
  }
}
